import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { GetPlantillas } from 'App/Administracion/Actions';
import { AdministracionContext } from "App/Administracion/store";
import { LayoutContext } from "App/Layout/store";
import { Link } from 'react-router-dom';
import { useAuth } from "react-oidc-context";

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    textAlignRight: {
        textAlign: "right"
    },
    iconHover: {
        '&:hover': {
            color: "rgb(61,30,144)",
            cursor: "pointer"
        }
    }
});

function Plantillas(props) {
    const { classes, theme } = props;
    const auth = useAuth();
    const administracionContext = useContext(AdministracionContext);
    const layoutContext = useContext(LayoutContext);

    useEffect(() => {
        GetPlantillas(administracionContext.dispatch)
    }, []);

    return (
        <div>
            <Grid item sm={12}>
                {layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Admin) ?
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Empresa</TableCell>
                                <TableCell>EmpresaID</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {administracionContext.state.plantillas.listado.map(row => (
                                <TableRow key={row.IdPlantilla}>
                                    <TableCell component="th" scope="row">
                                        {row.IdPlantilla}
                                    </TableCell>
                                    <TableCell>{row.IdEmpresa}</TableCell>
                                    <TableCell>{row.NomEmpresa}</TableCell>
                                    <TableCell><Link to={"/Administracion/Plantillas/" + row.IdPlantilla}>Editar</Link></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table> : <h5>No Autorizado</h5>}
            </Grid>
        </div>
    )
}

Plantillas.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Plantillas);